import type { EmergencyIncidentHistory, EmergencyModeWithStats } from '@/types/api'

export function emergencyCompletionLabel(action?: string | null): string {
  if (action === 'close') return 'Обращения закрыты'
  if (action === 'resolve') return 'Обращения решены'
  if (action === 'open') return 'Обращения переведены в открытые, в очередь операторов'
  return 'Результат обработки обращений не сохранён'
}


export function emergencyIncidentMetrics(
  group: EmergencyIncidentHistory,
  activeMode?: EmergencyModeWithStats,
  now = Date.now(),
) {
  const completion = [...group.events].reverse().find((event) => event.action === 'disabled')
  const completed = !!completion || group.is_active === false
  const live = activeMode?.id === group.opening.emergency_mode_id ? activeMode : undefined
  const enabledAt = group.opening.enabled_at || group.events.find((event) => event.action === 'enabled')?.created_at
  const timestamp = enabledAt ? Date.parse(enabledAt) : NaN
  const elapsed = Number.isFinite(timestamp) ? Math.max(0, Math.floor((now - timestamp) / 60_000)) : null
  return {
    completed,
    completion,
    currentCount: completed ? null : live?.tickets_count ?? null,
    finalCount: completion?.tickets_count ?? null,
    durationMinutes: completed ? completion?.duration_minutes ?? null : live || group.is_active === true ? live?.duration_minutes ?? elapsed : null,
    closing: !completed && live && ['queued', 'processing', 'failed'].includes(live.disable_job_status || '')
      ? { processed: live.disable_job_processed ?? 0, total: live.disable_job_total ?? 0 }
      : null,
  }
}
